import { useState } from "react";
import "./styles/global.css";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";

import Home      from "./pages/Home";
import Product   from "./pages/Product";
import About     from "./pages/About";
import Technical from "./pages/Technical";
import Contact   from "./pages/Contact";

const PAGES = {
  home:      Home,
  product:   Product,
  about:     About,
  technical: Technical,
  contact:   Contact,
};

export default function App() {
  const [page, setPage] = useState("home");

  const navigate = (id) => {
    setPage(id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const PageComponent = PAGES[page] ?? Home;

  return (
    <>
      <Navbar page={page} onNavigate={navigate} />
      <main>
        <PageComponent onNavigate={navigate} />
      </main>
      <Footer onNavigate={navigate} />
    </>
  );
}
